import * as SVG from '@svgdotjs/svg.js';
import { FillData, StrokeData } from '@svgdotjs/svg.js';

export type ShapeAppearance = { fill: FillData; stroke: StrokeData };

declare module '@svgdotjs/svg.js' {
  interface Shape {
    nonScalingStroke(): this;
    appearance(data: ShapeAppearance): this;
  }
}

SVG.extend(SVG.Shape, {
  nonScalingStroke: function () {
    return this as SVG.Shape; //.attr({ 'vector-effect': 'non-scaling-stroke' });
  },
  appearance: function (data: ShapeAppearance) {
    return this.fill(data.fill).stroke(data.stroke);
  },
});
